<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <div class="card">
    <div
      class="card-header d-flex align-items-center bg-primary font-weight-bold text-white"      
    >
      Test Center
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
    </div>
    <!-- <div class="card-header bg-white text-muted h4">Edit</div> -->
    <div class="card-body">
      <form @submit.prevent="postData">
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="name" class="font-weight-bold">Nama Test Center</label>
            <input
              type="text"
              class="form-control"
              id="namaTcInput"
              placeholder="Masukkan Nama Test Center"
              v-model="formData.namaTc"
              :class="{
                'is-invalid': $v.formData.namaTc.$error                
              }"
            />
          </div>        
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="email" class="font-weight-bold">Email</label>
              <input
                type="email"
                class="form-control"
                id="emailInput"
                placeholder="Masukkan Email Test Center"
                v-model="formData.email"
                :class="{
                  'is-invalid': $v.formData.email.$error
                }"
              />
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="alamat" class="font-weight-bold">Alamat</label>
            <textarea
              class="form-control"
              id="alamatInput"
              placeholder="Masukkan Alamat Test Center"
              v-model="formData.alamat"
              :class="{
                'is-invalid': $v.formData.alamat.$error
              }"
            ></textarea>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">            
            <label for="telp_op" class="font-weight-bold">Telepon Operator</label>
            <input
              type="number"
              class="form-control"
              id="telpOperatorInput"
              placeholder="Masukkan Nomor Telepon Operator"
              v-model="formData.telpOperator"
              :class="{
                'is-invalid': $v.formData.telpOperator.$error,                   
              }"
            />            
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="telp_tc" class="font-weight-bold">Telepon Test Center</label>
            <input
              type="number"
              class="form-control"
              id="telpTcInput"
              placeholder="Masukkan Nomor Telepon Test Center"
              v-model="formData.telpTc"
              :class="{
                'is-invalid': $v.formData.telpTc.$error,                   
              }"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="prov" class="font-weight-bold">Provinsi</label>            
            <multiselect
                label="name"
                required
                placeholder="Pilih Provinsi"
                @input="pilihProvinsi"
                v-model="multi_provinsi"
                :options="optionProvinsi"
                :class="{
                  'has-error': $v.multi_provinsi.$error
                }"
            ></multiselect>            
          </div>
        </div>
        <div class="form-row">          
          <div class="form-group col-md-12">
            <label for="prov" class="font-weight-bold">Kota/Kabupaten</label>
            <multiselect
                label="name"
                required
                placeholder="Pilih Kota / Kabupaten"
                @input="pilihKotaKab"
                v-model="multi_kota_kab"
                :options="optionKotaKabSelect"
                :class="{
                  'has-error': $v.multi_kota_kab.$error
                }"
              ></multiselect>               
          </div>          
        </div>
        <div class="form-row">
          <div class="col-md-12">
            <div id="mapTestCenter" style="height:400px"></div>
            <small><i class="color-grey">*Harap Klik/Pin titik lokasi Test Center</i></small>
            <br>
            <br>
            <div class="form-row">
              <div class="form-group col-md-6">
                  <label for="email" class="font-weight-bold">Latitude</label>
                  <input
                    type="text"
                    class="form-control"
                    id="latitude"
                    placeholder="°"
                    v-model="formData.latitude"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label for="alamat" class="font-weight-bold">Longitude</label>
                  <input
                    type="text"
                    class="form-control"
                    id="longtitude"
                    placeholder="°"
                    v-model="formData.longitude"
                  />
                </div>
            </div>
          </div>
          <div class="form-group col-md-12">            
            <div class="form-group mt-4">
              <label for="status" class="font-weight-bold">Status</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    value="1"
                    required
                    v-model="formData.status"
                    name="customRadio"
                    id="aktif"
                  />
                  <label class="custom-control-label" for="aktif">Aktif</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    value="0"
                    required
                    v-model="formData.status"
                    name="customRadio"
                    id="tidak_aktif"
                  />
                  <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                </div>
              </div>
              <span v-if="$v.formData.status.$error" class="text-danger">
                *Mohon pilih status
              </span>
            </div>
          </div>
        </div>
        <div class="card-footer bg-white border-0 ml-auto mb-3 mr-3 float-right">          
          <Button
            class="btn btn-md btn-success px-4 py-2"
            type="submit"

          >Simpan</Button>
        </div>
      </form>
    </div>
  </div>
</template>


<script>
import { required, email } from "vuelidate/lib/validators";

import DataTestCenterServices from "@/services/datamaster/data-test-center.service";
import { Location } from "@/mixins/lokasi/Location";
import { AlertUtils } from "@/mixins/AlertUtils"
import * as L from 'leaflet'
import * as esri from 'esri-leaflet'
import * as esri_geo from 'esri-leaflet-geocoder'
import mapMarker from '@/assets/icons/map-marker-alt-solid.svg';

export default {
  name: "Data Test Center",
  mixins : [Location,AlertUtils],
  data() {
    return {
      actionPost: "",
      optionKotaKabSelect : [],
      formData: {
        kodeTc: "",
        namaTc: "",
        email: "",
        alamat: "",
        kota: "",
        kabupaten: "",
        provinsi: "",
        telpOperator: "",
        telpTc: "",
        operator: "",
        status: "",
        idTc: "",
        latitude: "",
        longitude: ""
      },
    };
  },
  validations: {
    formData: {
      namaTc: { required },
      email: { required, email },
      alamat: { required },      
      telpOperator: { required },
      telpTc: { required }, 
      status: { required },      
    },
    multi_provinsi: { required },
    multi_kota_kab: { required }
  },
  mounted() {
    this.getAllProvinsi();
    this.getAllKotaKab();
    this.getData();
  },

  watch: {
    'formData.namaTc': function() {    
      this.$v.formData.namaTc.$touch();
      if(!this.$v.formData.namaTc.$error) {
        document.getElementById("namaTcInput").classList.add("is-valid")
      }
    },
    'formData.email': function() {
      this.$v.formData.email.$touch();
      if(!this.$v.formData.email.$error) {
        document.getElementById("emailInput").classList.add("is-valid")
      }
    },
    'formData.alamat': function () {
      this.$v.formData.alamat.$touch();
      if(!this.$v.formData.alamat.$error) {
        document.getElementById("alamatInput").classList.add("is-valid")
      }
    },
    'formData.telpOperator': function() {
      this.$v.formData.telpOperator.$touch();
      if(!this.$v.formData.telpOperator.$error) {
        document.getElementById("telpOperatorInput").classList.add("is-valid")
      }
    },
    'formData.telpTc': function() {
      this.$v.formData.telpTc.$touch();
      if(!this.$v.formData.telpTc.$error) {
        document.getElementById("telpTcInput").classList.add("is-valid")
      }
    }
  },

  methods: {    
    pilihKotaKab(val) {
      this.formData.kota = val.id_kota_kab;
      this.$v.formData.kota.$touch();
    },

    pilihProvinsi(val) {
      var kotakab = this.optionKotaKab.filter(el => el.id_provinsi === val.idProvinsi);
      this.optionKotaKabSelect = kotakab;
      this.multi_kota_kab = [];      
      this.formData.provinsi = val.idProvinsi
      this.$v.formData.provinsi.$touch();
    },
    
    getData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      DataTestCenterServices.getDetailTestCenter(this.$route.params.id_tc)
        .then(response => {
          loader.hide();          
          this.$v.$touch();
          vm.formData = response.data.singleData;
          var formdata = response.data.singleData;
                    
          setTimeout(function(){ 
            vm.multi_provinsi = vm.optionProvinsi.find(el => el.idProvinsi === vm.formData.provinsi);          
            vm.multi_kota_kab = vm.optionKotaKab.find(el => el.id_kota_kab === vm.formData.kota);
            var kotakab = vm.optionKotaKab.filter(el => el.id_provinsi === vm.formData.provinsi);
            vm.optionKotaKabSelect = kotakab;
          }, 1000);
          
          this.getKoordinat(formdata);
          // comment console console.log(response);
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
        });
    },
 
    getKoordinat(formData) {
      var vm = this;
      var lat = formData.latitude;
      var lon = formData.longitude;      
      
      var customMarker = L.icon({
        iconUrl: '/img/map-marker-alt-solid.svg',
        iconSize: [20, 40],
        iconAnchor: [14, 43.705878]
      });        

      var x = parseFloat(lat);
      var y = parseFloat(lon);      

      var map = L.map('mapTestCenter').setView([x, y], 13);

      L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png", {
        attribution:
          '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);

      vm.marker = L.marker([x, y], { icon: customMarker }).addTo(map);

      var arcgisOnline = esri_geo.arcgisOnlineProvider();
      var searchControl = esri_geo.geosearch({
          providers: [arcgisOnline]
      }).addTo(map);
      var results = L.layerGroup().addTo(map);

      searchControl.on('results', function(data){
        results.clearLayers();
        for (var i = data.results.length - 1; i >= 0; i--) {
          results.addLayer(L.marker(data.results[i].latlng));
          vm.marker = L.marker((data.results[i].latlng), { icon: customMarker }).addTo(map);
          vm.formData.latitude = data.results[i].latlng.lat;
          vm.formData.longitude = data.results[i].latlng.lng;
        }
      });
      
        if (vm.marker != undefined) {
          map.removeLayer(vm.marker);
        }
        vm.marker = L.marker([lat, lon], { icon: customMarker }).addTo(map);
        map.on("click", function(e) {
        // comment console console.log(e.latlng.lat, e.latlng.lng);
        lat = e.latlng.lat;
        lon = e.latlng.lng;
         

        // comment console console.log("Map ditandai pada LAT: " + lat + " dan LONG: " + lon);

        // comment console console.log(vm.marker);
        //hapus marker eksisting
        if (vm.marker != undefined) {
          map.removeLayer(vm.marker);
        }

        //nambah marker ketika klik
        var customMarker = L.icon({
          iconUrl: mapMarker,
          iconSize: [20, 40],
          iconAnchor: [14, 43.705878]
        });

        vm.marker = L.marker([lat, lon], { icon: customMarker }).addTo(map);

        let setLong = document.getElementById("longtitude");
        setLong.value = lon;
        setLong.dispatchEvent(new Event("input"));

        let setLat = document.getElementById("latitude");
        setLat.value = lat;
        setLat.dispatchEvent(new Event("input"));
      });
    },
    createData() {
      this.myModal = true;
      this.formData = {};
      this.actionPost = "insert";
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      this.actionPost = "update";
    },    

    postData() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        window.scrollTo({top: 0, behavior: 'smooth'});
        return;
      } else {          
        this.putData();
      }      
    },

    insertData(formData) {
      // comment console console.log(formData);
      // comment console console.log("posat");
      DataTestCenterServices.postDataTestCenter(formData)
        .then(response => {
          // comment console console.log(response);
          // this.myModal = false;
          this.alertEditSuccess();
          this.$v.$reset();
          setTimeout(this.$router.push({ path : "/data-master/data-test-center" }),1500);
          // this.getData("1");
        })
        .catch(error => {
          // comment console console.log(error);
          this.alertError();
        });
    },

    putData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      // comment console console.log("put");
      // comment console console.log(this.formData);

      DataTestCenterServices.putDataTestCenter(this.formData)
        .then(response => {

          loader.hide();
          // comment console console.log(response)
          this.myModal = false;
          this.clearValidations();
          this.alertEditSuccess();
          this.$router.push({ path : "/data-master/data-test-center" });
        })
        .catch(error => {
          // comment console console.log(error);

          this.alertError();
        });
    },

    clearValidations() {
      document.getElementById("namaTcInput").classList.remove("is-valid")
      document.getElementById("emailInput").classList.remove("is-valid")
      document.getElementById("alamatInput").classList.remove("is-valid")
      document.getElementById("telpOperatorInput").classList.remove("is-valid")
      document.getElementById("telpTcInput").classList.remove("is-valid")
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>